import React, { useState } from "react";
import { Spinner } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import styled from "styled-components";
import arrow from "../assets/arrow.png";
import { Footer, Header } from "../components/index";
import { Send } from "../helper";
const ContactUsPage = () => {
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [text, setText] = useState("");
  const [title, setTitle] = useState("");
  const [sending, setSending] = useState(false);
  const ContactNow = async (e) => {
    e.preventDefault();
    if (
      fname === "" ||
      lname === "" ||
      email === "" ||
      phone === "" ||
      text === "" ||
      title === "" ||
      text === ""
    ) {
      //add the empty fields notification here
      alert("Please fill all the fields");
    } else {
      setSending(true);
      let res = await Send("post", "/contact", {
        fname,
        lname,
        email,
        phone,
        text,
        title,
      });
      if (res.type === "success") {
        alert("Contact request sent!");
        setFname("");
        setLname("");
        setEmail("");
        setPhone("");
        setText("");
        setTitle("");
      } else {
        alert(res.msg);
      }
      setSending(false);
    }
  };
  return (
    <>
      <Header />
      <Wrapper>
        <div className="hero__Wrapper">
          <Container>
            <div className="contactUs__warapper">
              <div className="contactUs_header">
                <h1 className="indi__header_h1">Contact Us</h1>

                <p>
                  Tell us a little about yourself and we'll connect you with a
                  an agent who can share more about the product and answer any
                  questions you have.
                </p>
              </div>
              <div className="contactUs__from__wrapper">
                <div className="contactUs">
                  <form className="contactus__form">
                    <div className="whole__form">
                      <div className="form__name">
                        <div className="contactUs__first_name">
                          <input
                            value={fname}
                            onChange={(e) => setFname(e.target.value)}
                            type="text"
                            placeholder="First Name"
                          />
                        </div>

                        <div className="contactUs__last_name">
                          <input
                            value={lname}
                            onChange={(e) => setLname(e.target.value)}
                            type="text"
                            placeholder="Last Name"
                          />
                        </div>
                      </div>

                      <div className="from_email_pass">
                        <input
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          type="email"
                          placeholder="Email Address"
                        />
                      </div>

                      <div className="from_email_pass">
                        <input
                          value={phone}
                          onChange={(e) => setPhone(e.target.value)}
                          type="number"
                          placeholder="Phone Number"
                        />
                      </div>
                      <div className="from_email_pass">
                        <input
                          value={title}
                          onChange={(e) => setTitle(e.target.value)}
                          type="text"
                          placeholder="Title"
                        />
                      </div>
                      <div className="contactus__textarera">
                        <textarea
                          value={text}
                          onChange={(e) => setText(e.target.value)}
                          name="Comments"
                          rows="7"
                          cols="40"
                          placeholder="Write us a message"
                        ></textarea>
                      </div>
                    </div>

                    <button onClick={ContactNow} className="contactus__btn">
                      {sending ? <Spinner animation="border" /> : "Contact Us"}{" "}
                      <img className="fromArrowImg" src={arrow} alt="arrow" />
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </Container>
        </div>
        <div className="Svg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#E5EDFC"
              fill-opacity="1"
              d="M0,320L1440,64L1440,0L0,0Z"
            ></path>
          </svg>
        </div>
        <Footer />
      </Wrapper>
    </>
  );
};

const Wrapper = styled.div`
  @media screen and (max-width: 440px) {
    form.contactus__form .form__name {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      text-align: left;
      width: 100% !important;
      flex-direction: column;
      .contactUs__first_name {
        width: 100% !important;
        padding: 0 !important;
      }
      .contactUs__last_name {
        width: 100% !important;
        padding: 0 !important;
        margin-top: 20px;
      }
    }
    form.contactus__form {
      width: 100% !important;
      padding: 0 36px !important;
    }
    .contactUs_header h1 {
      font-family: Gilroy;
      font-style: normal !important;
      font-weight: 800;
      font-size: 50px !important;
      line-height: 50px !important;
      color: #6300ff;
      width: 100% !important;
      height: 75px;
    }
    .contactUs_header p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 16px !important;
      line-height: 30px !important;
      color: #455880;
      margin-top: 50px;
      width: 90% !important;
      height: 120px;
      margin-top: 10px !important;
    }
    .Svg {
      margin: -31px 0 188px 0 !important;
    }
  }

  @media screen and (max-width: 768px) {
    .hero__Wrapper {
      background: #e5edfc;
      width: 100vw;
      height: 60rem !important;
    }
    .contactUs__warapper {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex !important;
      padding: 8rem 0 0 0 !important;
      justify-content: center !important;

      flex-direction: column;
    }
    .contactUs__from__wrapper {
      z-index: 999;
      transform: translate(0px, 66px);
      width: 100%;
    }
    .contactUs {
      background: #ffffff;
      border-radius: 20px;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-flex-direction: column;
      -ms-flex-direction: column;
      flex-direction: column;
      -webkit-align-items: center;
      -webkit-box-align: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
      width: 100% !important;
      padding: 60px 0 60px 0;
      margin-left: 0px !important;
    }
    form.contactus__form {
      width: 100% !important;
      padding: 0 52px;
      .form__name {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        text-align: left;
        width: 100% !important;
        .contactUs__first_name {
          width: 100% !important;
          padding: 0 5px 0 0;
          input {
            background: #ffffff;
            border: 1.5px solid #dbe0eb;
            box-sizing: border-box;
            border-radius: 4px;
            width: 100%;
            height: 45px;
            padding-left: 25px;
            margin-right: 10px;
            outline: none;
          }
        }
        .contactUs__last_name {
          width: 100% !important;
          padding: 0 0 0 5px;
          input {
            background: #ffffff;
            border: 1.5px solid #dbe0eb;
            box-sizing: border-box;
            border-radius: 4px;
            width: 100%;
            height: 45px;
            padding-left: 25px;
            margin-right: 10px;
            outline: none;
          }
        }
      }
      .from_email_pass {
        width: 100%;
        margin-top: 20px;
        input {
          background: #ffffff;
          border: 1.5px solid #dbe0eb;
          box-sizing: border-box;
          border-radius: 4px;
          width: 466px;
          height: 45px;
          padding-left: 25px;
          outline: none;
          width: 100%;
        }
      }
      .contactus__textarera {
        margin-top: 20px;
        width: 100%;
        textarea {
          background: #ffffff;
          border: 1.5px solid #dbe0eb;
          border-radius: 4px;
          width: 466px;
          height: 160.75px;
          outline: none;
          padding-left: 25px;
          padding-top: 10px;
          width: 100%;
        }
      }
    }
    .Svg {
      margin: -31px 0 142px 0;
    }
  }
  .hero__Wrapper {
    background: #e5edfc;
    width: 100vw;
    height: 33rem;
  }
  img.fromArrowImg {
    padding: 0 0 0 40px;
  }
  .contactUs__from__wrapper {
    z-index: 999;
    /* // transform: translate(0px, 66px); */
  }
  .Svg {
    margin: -31px 0 142px 0;
  }
  .contactUs__warapper {
    display: flex;
    padding: 8rem 0 0 0;
  }
  .contactUs {
    background: #ffffff;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 515px;
    padding: 60px 0 60px 0;
    margin: auto;
    margin-left: 40px;
  }

  .whole__form {
    margin-bottom: 90px;
  }

  .contactUs_header {
    h1 {
      font-family: Gilroy;
      font-style: normal;
      font-weight: 800;
      font-size: 56px;
      line-height: 72px;
      color: #6300ff;
      width: 568px;
      height: 75px;
    }
    p {
      font-family: Manrope;
      font-style: normal;
      font-weight: 500;
      font-size: 20px;
      line-height: 38px;
      color: #455880;
      margin-top: 50px;
      width: 500px;
      height: 120px;
    }
  }
  .form__name {
    display: flex;
    text-align: left;
  }

  form.contactus__form {
    width: 468.12px;
    /* height: 482px; */
  }

  .contactUs__first_name {
    input {
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      box-sizing: border-box;
      border-radius: 4px;
      width: 219px;
      height: 45px;
      padding-left: 25px;
      margin-right: 10px;
      outline: none;
    }
  }
  .contactUs__last_name {
    input {
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      box-sizing: border-box;
      border-radius: 4px;
      width: 237px;
      height: 45px;
      padding-left: 25px;
      outline: none;
    }
  }

  .from_email_pass {
    width: 100%;
    margin-top: 20px;

    input {
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      box-sizing: border-box;
      border-radius: 4px;
      width: 466px;
      height: 45px;
      padding-left: 25px;
      outline: none;
    }
  }

  .contactus__textarera {
    margin-top: 20px;
    textarea {
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      border-radius: 4px;
      width: 466px;
      height: 160.75px;
      outline: none;
      padding-left: 25px;
      padding-top: 10px;
    }
  }

  button.contactus__btn {
    background: #6300ff;
    border-radius: 4px;
    font-family: Manrope;
    font-style: normal;
    font-weight: 800;
    font-size: 17px;
    line-height: 25px;
    text-align: center;
    color: #ffffff;
    width: 100%;
    outline: none;
    border: none;
    padding: 10px 0px;
    letter-spacing: 1px;
  }

  .contactUs__warapper.row {
    transform: translateY(135px);
  }

  .contactUs_header {
    padding-top: 70px;
  }
`;

export default ContactUsPage;
